define("SuiteCommerce.ItemRecSys.InViewportObserver", ["require", "exports", "jQuery"], function (require, exports, jQuery) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.InViewportObserver = void 0;
    /**
     * Observes element visibility in browser viewport,
     * Listens to scroll and resize events
     * And calls the passed callback when the observed element is partially visible
     */
    var InViewportObserver = /** @class */ (function () {
        /**
         *
         * @param view Widget Backbone view
         * @param percentInViewportThreshold percent threshold of visibility when callback is fired
         * @param callback
         */
        function InViewportObserver(view, percentInViewportThreshold, callback) {
            if (percentInViewportThreshold === void 0) { percentInViewportThreshold = 75; }
            this.checkTimeout = null;
            this.$element = view.$el;
            this.percentInViewportThreshold = percentInViewportThreshold;
            this.callback = callback;
            this.fired = false;
            this.eventListenString = "scroll." + view.cid + " resize." + view.cid;
            jQuery(window).on(this.eventListenString, this.scheduleCheck.bind(this));
            this.scheduleCheck();
        }
        InViewportObserver.prototype.destroy = function () {
            jQuery(window).off(this.eventListenString);
            clearTimeout(this.checkTimeout);
        };
        InViewportObserver.prototype.scheduleCheck = function () {
            clearTimeout(this.checkTimeout);
            this.checkTimeout = setTimeout(this.doCheck.bind(this), InViewportObserver.THROTTLE_TIMEOUT);
        };
        InViewportObserver.prototype.doCheck = function () {
            if (this.fired) {
                return;
            }
            if (this.isElementVisibleAboveThreshold()) {
                this.fired = true;
                this.callback();
                this.destroy();
            }
        };
        InViewportObserver.prototype.getElementVisiblePct = function () {
            var windowHeight = $(window).height(), docScroll = $(document).scrollTop(), divPosition = this.$element.offset().top, divHeight = this.$element.height(), hiddenBefore = docScroll - divPosition, hiddenAfter = (divPosition + divHeight) - (docScroll + windowHeight);
            // out of view
            if ((docScroll > divPosition + divHeight) || (divPosition > docScroll + windowHeight)) {
                return 0;
            }
            var result = 100;
            if (hiddenBefore > 0) {
                result -= (hiddenBefore * 100) / divHeight;
            }
            if (hiddenAfter > 0) {
                result -= (hiddenAfter * 100) / divHeight;
            }
            // adjust for when viewport < elem
            if (divHeight > windowHeight) {
                result *= (divHeight / windowHeight);
            }
            return Math.round(result);
        };
        ;
        InViewportObserver.prototype.isElementVisibleAboveThreshold = function () {
            return this.getElementVisiblePct() >= this.percentInViewportThreshold;
        };
        InViewportObserver.THROTTLE_TIMEOUT = 100;
        return InViewportObserver;
    }());
    exports.InViewportObserver = InViewportObserver;
});
